export default function TrustSection() {
  const trustBadges = [
    { name: 'Enterprise', icon: 'ri-building-line' },
    { name: 'Secure', icon: 'ri-shield-check-line' },
    { name: 'ISO Certified', icon: 'ri-award-line' },
    { name: 'Cloud Ready', icon: 'ri-cloud-line' },
    { name: '24/7 Support', icon: 'ri-customer-service-2-line' },
  ];

  return (
    <section id="hakkimizda" className="bg-gradient-to-b from-[#0F172A] via-[#1E293B] to-[#0F172A] py-32 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#2563EB] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0EA5E9] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-[900px] mx-auto px-8 text-center relative z-10">
        {/* Headline */}
        <h2 className="notion-fade-in text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Üretim ve İthalat Devleri İçin Tasarlandı
        </h2>

        {/* Supporting Text */}
        <p className="notion-fade-in text-[22px] text-[#CBD5E1] leading-relaxed mb-16" style={{ animationDelay: '0.1s' }}>
          Tedarik zincirinizin en hassas noktalarını güvence altına alın.
        </p>

        {/* Trust Indicators */}
        <div className="flex flex-wrap justify-center items-center gap-12 mt-16">
          {trustBadges.map((badge, index) => (
            <div
              key={index}
              className="notion-scale-in flex flex-col items-center gap-3 hover:scale-110 smooth-transition cursor-pointer group"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="w-16 h-16 rounded-full bg-white/10 group-hover:bg-white/20 flex items-center justify-center smooth-transition">
                <i className={`${badge.icon} text-white text-3xl group-hover:scale-125 smooth-transition`}></i>
              </div>
              <span className="text-[#CBD5E1] text-sm font-semibold whitespace-nowrap group-hover:text-white smooth-transition">
                {badge.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
